<!-- checks: vendorCode -->
<sbnb-apps-detail-page
  vendorCode="jervis_systems"
  name="Jervis Systems"
  logoTile="/assets/images/apps/jervis.png"
  builtBy="Jervis Systems"
  builtByLink="https://www.jervis.systems"
  [categories]="['Home automation']"
  [permissions]="[
    AppPermission.calendarRead,
    AppPermission.propertyListingRead,
    AppPermission.enrichmentRead,
    AppPermission.enrichmentSmartLockCode
  ]"
  [beta]="true"
  [helpArticles]="[
    {
      id: '8981611',
      title: 'Connect Hospitable with Jervis Systems to automate smart lock codes'
    }
  ]">
  <section class="jervis-content">
    <div class="grid-container">
      <div>
        <h4>🔐 Maximize security with keyless access</h4>
        <span>
          With Jervis Systems, you can forget about handing out keys, setting up lockboxes, and reusing codes for
          multiple guests. We help you and your guests feel safer with automated, keyless access you can monitor from
          anywhere, whether it's smart lockboxes or garage doors.
        </span>
      </div>

      <div>
        <h4>⏩ Save time with automation</h4>
        <span>
          You have a lot on your plate when it comes to managing your rental properties. Jervis Systems takes over
          delivering PIN codes and access details to your guests for every reservation. You're free to do more with your
          time!
        </span>
      </div>

      <div>
        <h4>🔎 Manage everything from one place</h4>
        <span>
          Dealing with multiple apps is a headache. By working with top-rated smart locks, garage door openers,
          thermostats, smart lights, smart switches, and more, Jervis Systems allows property owners and managers to
          manage all devices from a single, user-friendly dashboard.
        </span>
      </div>

      <div>
        <h4>😊 Elevate your guest experience</h4>
        <span>
          Today, your guests have come to expect greater ease and convenience during their stay. Surprise them with a
          seamless check-in experience thanks to keyless access. Automatically set property temperatures before a guest
          checks in and after a guest checks out. Never have the AC or heat on too high when your property is vacant
          again!
        </span>
      </div>

      <div>
        <h4>🧹 Set access times</h4>
        <span>
          No one accesses your property without your permission, whether it’s guests, cleaning companies, or maintenance
          personnel. The ability to set access times for each reservation ensures that only the current guests can
          enter.
        </span>
      </div>
    </div>

    <sbnb-image-carousel
      [images]="[
        '/assets/images/apps/jervis/jervis-3.png',
        '/assets/images/apps/jervis/jervis-2.jpg'
      ]"></sbnb-image-carousel>
  </section>
  <ng-container description>
    <p>
      Jervis Systems is a guest access and smart home device automation platform that allows property owners and
      managers to automate their short-term rentals, vacation homes, and boutique hotels from anywhere in the world.
      Owners and managers can create five-star guest experiences while avoiding the technical hassle and headache of
      managing multiple apps and smart home devices.
    </p>
    <p>
      Jervis connects with numerous top-rated smart locks, garage door openers, thermostats, smart lights, smart
      switches, and much more to automate temperature and property access for guests, cleaning companies, and
      maintenance personnel. Jervis Systems makes property automation simple and secure, allowing you to focus on
      growing your business.
    </p>
  </ng-container>
</sbnb-apps-detail-page>
